import React, { useState } from "react";
import { Row, Col, Card, Tooltip } from "antd";

import "./CodStats.css";

import {
  COD_STAT_CARDS,
  getCodDashboardFilter,
} from "./CodDashboardStatus";

const CodStats = ({ stats, onSelect, currencyCode }) => {
  const [selected, setSelected] = useState();

  const handleSelect = (selected) => {
    setSelected(selected);
    onSelect(getCodDashboardFilter(selected));
  };

  return (
    <Row className="mb-2 cod-stats" gutter={[16, 16]}>
      {COD_STAT_CARDS.map((card) => (
        <Col
          key={card.key}
          xs={24}
          sm={12}
          md={8}
          xl={6}
          style={{ display: "flex" }}
        >
          <Card
            hoverable
            onClick={() => handleSelect(card.key)}
            className={selected === card.key ? "selected" : ""}
            style={{ width: "100%", height: "100%" }}
          >
            <div style={{ textAlign: "center", color: "#575757" }}>
              <Tooltip title={card.title}>
                <p style={{ fontSize: 24 }}>{card.title}</p>
              </Tooltip>

              {stats[card.statKey] && (
                <p className="user-info">
                  Count: <strong>{stats[card.statKey]?.count}</strong>
                  <br />
                  Amount:{" "}
                  <strong>
                    {currencyCode} {stats[card.statKey]?.amount}
                  </strong>
                </p>
              )}
            </div>
          </Card>
        </Col>
      ))}
    </Row>
  );
};

export default CodStats;